import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=694a0f27&"
import script from "./Task.vue?vue&type=script&lang=ts&"
export * from "./Task.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports